import { _get } from "lib/rest";
import { commonGetType, channelType } from "../common";

export const getWordStatistics = async (
  pid: number,
  data: { unit: "day" | "month" | "week" } & commonGetType
) => _get(`/sentiment/project/${pid}/statistics/words/`, data);
export const getChannelTalkStatistics = async (
  pid: number,
  data: { unit: "day" | "month" | "week" } & commonGetType
) => _get(`/sentiment/project/${pid}/statistics/channel-talk/`, data);
export const getGooglePlayStatistics = async (
  pid: number,
  data: { unit: "day" | "month" | "week" } & commonGetType
) => _get(`/sentiment/project/${pid}/statistics/google-play/`, data);
export const getAppStoreStatistics = async (
  pid: number,
  data: { unit: "day" | "month" | "week" } & commonGetType
) => _get(`/sentiment/project/${pid}/statistics/app-store/`, data);

export const getAspectChannelTalkSummary = async (pid: number) =>
  _get(`/sentiment/project/${pid}/aspect/channel-talk/`);

export const getUsageSummary = async (pid: number, data: commonGetType) =>
  _get(`/sentiment/project/${pid}/dashboard/usage/`, data);

export const getWordCloud = async (
  pid: number,
  data: { n: number } & commonGetType
) => _get(`/sentiment/project/${pid}/dashboard/wordcloud/`, data);

//word의 aspect를 가져온다
export const getWordsAspects = async (
  pid: number,
  data: commonGetType & channelType
) => _get(`/sentiment/project/${pid}/dashboard/aspects/`, data);

// thread를 가져온다.
export const getWordsList = async (
  pid: number,
  data: commonGetType & channelType
) =>
  _get(`/sentiment/project/${pid}/text/`, {
    ...data,
    type: data.type?.toString(),
  });

//aspect가지고 찾는다
export const getWordsFromAspect = async (
  pid: number,
  data: { aspect: string } & commonGetType & channelType
) => _get(`/sentiment/project/${pid}/text/`, data);
